import React, { useEffect, useContext } from "react";

import PlayerManager from "../service/player-manager";
import { PlayerStateContext, PlayerQueueContext } from "../provider";

export default () => {
  const [playerState, setPlayerState] = useContext(PlayerStateContext);
  const [playerQueue, setPlayerQueue] = useContext(PlayerQueueContext);

  // todo:separate these
  useEffect(() => {
    PlayerManager.registerStateManager([setPlayerState, setPlayerQueue]);
  }, [playerState, playerQueue]);

  return <></>;
};
